import { NightCallBillRateTypeEnum } from '../shared/models/enums/job-night-call-bill-rate-type.enum';
import { PayPeriodTypeEnum } from '../shared/models/enums/pay-period-type.enum';
import { VaccinationTypesEnum } from './locums-constants';
import { BoardCertification } from './models/board-certification.model';
import { StateLicense } from './models/state-license.interface';
import { UnitCertification } from './models/unit-certification.interface';
import { UnitDetails } from './models/unit-details.model';

export class LocumsUtility {
    public static getBoardCertificationDetails(boardCertification: BoardCertification): string {
        if (boardCertification.isBoardCertified && boardCertification.isBoardEligible) {
            return 'BC/BE';
        }

        if (boardCertification.isBoardCertified) {
            return 'BC';
        }

        if (boardCertification.isBoardEligible) {
            return 'BE';
        }
        return null;
    }

    public static getControlledSubstanceTitle(state, profession): string {
        return (state === 'California' || state === 'CA') && profession === 'Nurse Practitioner'
            ? 'Furnishing License'
            : 'CSR';
    }

    public static getVaccinationType(vaccinationTypeId: number): string {
        if (vaccinationTypeId === VaccinationTypesEnum.Covid19) {
            return 'COVID-19';
        }

        if (vaccinationTypeId === VaccinationTypesEnum.Flu) {
            return 'Flu';
        }

        return undefined;
    }

    public static getUnitCertificationsDetails(unitCertification: UnitCertification): string {
        const message = unitCertification.isRequired ? 'Required' : 'Preferred';
        return message;
    }

    public static getTraumaLevel(
        isTraumaFacility: boolean = false,
        hasAdultTrauma: boolean = false,
        hasPedsTrauma: boolean = false,
        isTraumaLevel1: boolean = false,
        isTraumaLevel2: boolean = false,
        isTraumaLevel3: boolean = false,
        isTraumaLevel4: boolean = false
    ): string {
        if (!isTraumaFacility) {
            return '';
        }

        let message = '';

        if (hasAdultTrauma) {
            message = message.concat('Adult ');
        }

        if (hasPedsTrauma) {
            message = message.concat('Peds ');
        }

        if (isTraumaLevel1) {
            message = message.concat('I ');
        }

        if (isTraumaLevel2) {
            message = message.concat('II ');
        }

        if (isTraumaLevel3) {
            message = message.concat('III ');
        }

        if (isTraumaLevel4) {
            message = message.concat('IV ');
        }

        return message.trimEnd();
    }

    public static getStateLicenseDetails(stateLicense: StateLicense): string {
        let message = '';

        if (stateLicense.isRequired) {
            message = message.concat('Required, ');
        }

        if (stateLicense.isImlcAccepted) {
            message = message.concat('IMLC Accepted, ');
        }

        if (stateLicense.isCompactAccepted) {
            message = message.concat('Compact Accepted, ');
        }

        return message.replace(/,\s*$/, '');
    }

    public static translateExperience(experience: string): string {
        return !experience || experience === 'None' ? null : experience.replace(/^is/, '');
    }

    public static shouldShowExperience(unitDetails: UnitDetails): boolean {
        return (
            !!unitDetails?.chartingType &&
            !!unitDetails?.chartingExperience &&
            unitDetails?.chartingExperience !== 'None'
        );
    }

    public static getNightCallBillRateTypeString(nightCallBillRateType: NightCallBillRateTypeEnum): string {
        return nightCallBillRateType === NightCallBillRateTypeEnum.PerShift ? '/shift' : '/hour';
    }

    public static getPayFormatPeriodSpecification(payPeriodType: PayPeriodTypeEnum): string {
        return payPeriodType === PayPeriodTypeEnum.Daily ? '/day' : '/hour';
    }

    public static getPayRangePeriodSpecification(payPeriodType: PayPeriodTypeEnum): string {
        return payPeriodType === PayPeriodTypeEnum.Daily ? '/day' : '/hr';
    }
}
